/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import type { CancellationPoliciesWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { RECEIVE_CANCELLATION } from '../constants'
import { meta } from './meta'
import type { ActionTypes } from './types'

export const cancellationReducer = combineReducers<CancellationPoliciesWithMeta, ActionTypes>({
  data: handleAction<
    CancellationPoliciesWithMeta['data'],
    ActionTypes,
    typeof RECEIVE_CANCELLATION
  >(
    RECEIVE_CANCELLATION,
    (
      state,
      {
        payload: {
          cancellation: { cancellations },
        },
      }
    ) => cancellations,
    null
  ),
  meta,
})
